module.exports = __webpack_public_path__ + "assets/projects/berlinfuchs/project-header.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/berlinfuchs/project-header.jpg
// module id = 37
// module chunks = 0